export default function Disclaimer() {
  return (
    <article className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-16 font-ui text-[#1A362D] leading-relaxed">
      <p className="label-eyebrow text-[#C05C45]">Informazioni</p>
      <h1 className="mt-2 font-display text-4xl sm:text-5xl tracking-tight">Disclaimer legale</h1>

      <section className="mt-10 space-y-4">
        <h2 className="font-display text-2xl mt-8">Natura del servizio</h2>
        <p>Per manina è una piattaforma indipendente che raccoglie indirizzi pubblici di scuole dell'infanzia italiane (fonte: anagrafe ufficiale MIUR) e esperienze volontarie da parte dei genitori. Non siamo affiliati alle strutture elencate, né riceviamo compensi per la loro inclusione.</p>

        <h2 className="font-display text-2xl mt-8">Contenuti generati dagli utenti</h2>
        <p>Le esperienze rappresentano l'opinione personale di chi le scrive. Per manina non verifica preventivamente i contenuti pubblicati e non è responsabile dell'accuratezza, completezza o affidabilità degli stessi. Le esperienze devono rispettare la legge, il rispetto reciproco e la dignità delle persone.</p>

        <h2 className="font-display text-2xl mt-8">Linee guida</h2>
        <ul className="list-disc pl-6 space-y-1">
          <li>Sono ammesse solo esperienze basate su esperienze dirette.</li>
          <li>Non sono ammessi insulti, diffamazioni, dati personali di terzi (es. nomi di insegnanti o bambini).</li>
          <li>I contenuti palesemente non conformi possono essere rimossi dopo segnalazione di altri utenti verificati.</li>
        </ul>

        <h2 className="font-display text-2xl mt-8">Segnalazioni</h2>
        <p>Le strutture che ritengano una esperienza lesiva possono richiederne la revisione contattando il titolare del sito.</p>

        <h2 className="font-display text-2xl mt-8">Limitazioni di responsabilità</h2>
        <p>L'utilizzo della piattaforma è a discrezione dell'utente. Per manina declina ogni responsabilità per decisioni prese sulla base dei contenuti pubblicati. Si raccomanda sempre di visitare di persona la struttura prima di una scelta definitiva.</p>
      </section>
    </article>
  );
}
